export var SourceCrawlerInterval;
(function (SourceCrawlerInterval) {
    SourceCrawlerInterval["M15"] = "15m";
    SourceCrawlerInterval["M30"] = "30m";
    SourceCrawlerInterval["H1"] = "1h";
    SourceCrawlerInterval["H4"] = "4h";
    SourceCrawlerInterval["D1"] = "1d";
})(SourceCrawlerInterval || (SourceCrawlerInterval = {}));
export var SourceCrawlerType;
(function (SourceCrawlerType) {
    SourceCrawlerType["PANDA"] = "panda";
    SourceCrawlerType["CUSTOM"] = "custom";
    SourceCrawlerType["INSTAGRAM"] = "instagram";
})(SourceCrawlerType || (SourceCrawlerType = {}));
